import { s, typographyTokens, type SpacingToken } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const detailPageSectionGapToken: SpacingToken = '2xl';
export const detailPageSectionGap = s(detailPageSectionGapToken);

export const detailPageHeaderMetaSx = {
  fontSize: typographyTokens.body.fontSize,
  fontVariantNumeric: 'tabular-nums',
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
} satisfies SxProps<Theme>;
